import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useClient } from "../../context/ClientContext";

// RolRoute deja pasar al dueño (rol 1) y a los roles que se le indiquen. El
// backend vuelve a chequear cada ruta: esto es solo para no mostrar pantallas
// que van a responder 403.
export const RolRoute = ({ roles = [], children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { clientPath } = useClient();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to={clientPath('/login')} replace />;
  if (user?.id_rol !== 1 && !roles.includes(user?.id_rol)) return <Navigate to={clientPath('/')} replace />;

  return children;
};
